<div class="container-fluid d-grid h-100" style="grid-template-rows: auto 1fr;grid-template-columns: 100%">
    <!-- <div class="d-flex flex-wrap mb-3">

        <ng-select [clearable]="false" [searchable]="false"  [(ngModel)]="selectedStatus"
            [placeholder]="'فلتر بحالة المهام'" (change)="selectStatus($event)"
            *ngIf="filterStatus && filterStatus?.length">
           
            <ng-option [value]="item.id" *ngFor="let item of filterStatus">
                {{item?.status_Name}}
            </ng-option>
        </ng-select> 
    </div> -->
    <div class="control-section w-100">
        <div *ngIf="gettingData" class="d-flex justify-content-center align-items-center">
            <div class="spinner-border text-primary spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <ejs-grid *ngIf="!gettingData" (rowSelected)="rowSelected($event)" [toolbar]="toolbar"
            (actionBegin)="actionBegin($event)" [enableInfiniteScrolling]="false" #mg_grid [enableStickyHeader]="true"
            [dataSource]='allTasks' [editSettings]="editSettings" [loadingIndicator]='loadingIndicator'
            [pageSettings]="pagesSettings" height="100%" width="100%" [filterSettings]='filterSettings'
            [allowExcelExport]="true" [allowPaging]='true' [allowGrouping]='true' [allowSorting]='true'
            [allowFiltering]='true' (toolbarClick)='toolbarClick($event)'>
            <e-columns>
                <e-column [allowFiltering]="false" field="no" headerText="#" width="50" [visible]="true"
                    [isPrimaryKey]="true">
                    <ng-template #template let-data>
                        {{data.no }}
                    </ng-template></e-column>

                <e-column field="createdDate" headerText="التاريخ" width="100">
                    <ng-template #template let-data>
                        {{data.createdDate | date}}
                    </ng-template>
                </e-column>
                <e-column field="subject" headerText="الموضوع" width="150"></e-column>
                <e-column field="endDate" headerText="تاريخ الإنتهاء المتوقع" width="150">
                    <ng-template #template let-data>
                        {{data.endDate | date}}
                    </ng-template>
                </e-column>
                <e-column field="remainigDays" headerText="المتبقي" width="100">
                    <ng-template #template let-data>
                        {{data?.remainigDays > 0 ? data?.remainigDays + ' يومًا': 'لم يتبق'}}
                    </ng-template>
                </e-column>
                <e-column field="stakeholder" headerText="الجهـــة" width="150"></e-column>
                <e-column field="responsible" headerText="المسؤول" width="150"></e-column>
                <e-column field="responsible" headerText="منشئ المهمة" width="150"></e-column>

                <e-column field='status' headerText='الحالــة' [allowFiltering]="true" clipMode='EllipsisWithTooltip'
                    width='150'>
                    <ng-template #template let-data>
                        <span [ngSwitch]="data?.status">
                            <!-- <span class="badge " *ngSwitchCase="'متأخر'" style="background-color: #FDB39C;">{{
                                data?.status }}</span> -->
                            <span class="badge " *ngSwitchCase="'Completed'"
                                style="background-color: #11B75A;">مكتمل</span>
                            <span class="badge " *ngSwitchCase="'Reported'"
                                style="background-color: rgba(166, 181, 0, 1);">تمت الإفادة</span>
                            <span class="badge " *ngSwitchCase="'NotCompleted'" style="background-color: black;"> غير
                                مكتملة</span>
                            <!-- <span class="badge " *ngSwitchCase="'للمتابعة'" style="background-color: #D9BB41;">{{
                                data?.status }}</span> -->
                            <span class="badge " *ngSwitchCase="'Current'" style="background-color: #B8C7FF;">جاري
                                العمل</span>
                            <span class="badge " *ngSwitchCase="'New'" style="background-color: #3957D3;">جديدة</span>
                            <span class="badge " *ngSwitchDefault style="background-color: #013F1B;">{{ data?.status
                                }}</span>
                        </span>


                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>